// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"6e428dd0","70":"cf7584a9","71":"cb69c635","261":"e1170399","398":"5e58ef12","453":"ec91ab41","481":"3a9ac219","569":"0a45bca2","663":"33f655da","751":"d6087865","784":"7b9e6ac1","795":"69a4bb85","823":"2448cebd","987":"b8672b40"}[chunkId] + ".chunk.js";
};